var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4595 37.2044C16.0032 37.2044 18.0652 35.1423 18.0652 32.5986C18.0652 30.055 16.0032 27.9929 13.4595 27.9929C10.9158 27.9929 8.85376 30.055 8.85376 32.5986C8.85376 35.1423 10.9158 37.2044 13.4595 37.2044Z",
    fill: "#FF06B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2156 27.9481C25.6596 27.6965 23.3836 29.5646 23.1321 32.1207C22.8806 34.6767 24.7487 36.9527 27.3047 37.2042C27.6076 37.234 27.9128 37.234 28.2156 37.2042C30.7717 36.9527 32.6398 34.6767 32.3883 32.1207C32.171 29.9124 30.4238 28.1653 28.2156 27.9481ZM37.6954 10.4195C37.5828 10.2509 37.4296 10.1134 37.2498 10.0196C37.0701 9.9258 36.8696 9.87879 36.6669 9.88288H31.5693V9.79345C31.5697 4.38503 27.1856 0.000349363 21.7772 2.08764e-08C16.3689 -0.000349321 11.9842 4.38372 11.9838 9.79214V9.88288H8.18298L6.88623 3.9804C6.81625 3.68864 6.65047 3.42876 6.41539 3.24231C6.18031 3.05587 5.88951 2.95363 5.58947 2.95194H0V5.63488H4.51629L8.67486 24.7285C8.72801 25.0324 8.88778 25.3074 9.12545 25.5041C9.36312 25.7008 9.66314 25.8063 9.97162 25.8017H33.358C33.658 25.8 33.9488 25.6977 34.1838 25.5113C34.4189 25.3248 34.5847 25.065 34.6547 24.7732L37.9637 11.5374C38.0115 11.3432 38.0121 11.1403 37.9654 10.9458C37.9187 10.7513 37.8261 10.5708 37.6954 10.4195ZM21.7766 16.9033C17.85 16.9033 14.6668 13.7201 14.6668 9.79345C14.6668 5.86685 17.85 2.68364 21.7766 2.68364C25.7032 2.68364 28.8864 5.86685 28.8864 9.79345C28.862 13.7099 25.693 16.8788 21.7766 16.9033Z",
    fill: "#FF06B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7034 9.92784L18.244 7.42375L16.3212 9.30182L19.7196 12.7449C19.9673 12.9977 20.3048 13.1423 20.6587 13.1474C20.8314 13.1558 21.004 13.1284 21.1656 13.0669C21.3273 13.0053 21.4744 12.9109 21.5977 12.7896L27.2319 7.46847L25.3985 5.50098L20.7034 9.92784Z",
    fill: "#FF06B7"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.3331435e377513e86b8c0e510949e908.svg";
export { ForwardRef as ReactComponent };